export const storage = {
	zeroProducts: {
		noProproductIsSelected: "No product selected",
	},
	removeProduct: {
		noProproductIsSelected: "No product selected",
	},
	layout: {
		goBack: "Back",
	},
	indicators: {
		cost: {
			title: "Total Inventory Amount",
		},
		turnover: {
			high: "High turnover",
			low: "Low turnover",
		},
		zeroed: {
			title: "Zero count products",
			seeMore: "See More",
		},
		intervalNotice: "Values referring to the last 90 days",
		updatedAt: "Updated on {{date}}",
		noZeroedProductsFound: "No zeroed products found",
		arialLabel: {
			dashboardTitle: "Storage metrics dashboard",
			indicatorsList: "Storage indicators",
			dataVisualization: "{{title}} data visualization",
			seeMoreButton: "See more products with zero quantity",
			zeroedProductsPreview: "Products with zero quantity preview",
			storageUnit: "{{name}} storage unit",
			productWithZeroQuantity: "{{name}}, product with zero quantity",
		},
	},
	modalXML: {
		title: "Import XML",
		warningMessage: {
			line1:
				"Select the target stock, download the example spreadsheet, fill it in and import it again.",
			line2:
				"Attention! The value of the products is informed in cents. Ex: 123 equals {{currencySymbol}} 1.23",
		},
		form: {
			label: {
				storage: "Stock",
				xml: "XML",
			},
			placeholder: {
				xml: "Choose an .xml file to import",
			},
			validation: {
				missingField: "Required field",
			},
			submit: "Import XML",
		},
	},
	modalManualChange: {
		title: {
			add: 'Add product "{{prodName}}"',
			subtract: 'Remove product "{{prodName}}"',
		},
		okText: {
			add: "Add Product",
			subtract: "Remove Product",
		},
		cancel: "Cancel",
		message: {
			add: "Type the quantity of product you want to add and the cost price",
			subtract: "Enter the amount you want to remove and a note if necessary",
		},
		form: {
			hasProductionRuleWarning:
				"This product has a technical sheet and its items will be reduced from stock only when they are with no stock",
			label: {
				quantity: "Quantity",
				costPrice: "Cost price",
				obs: "Observation",
			},
			validation: {
				invalidQuantity: "Invalid quantity",
				missingProductInfo: "Missing product information",
				missingActionInfo: "Missing action info",
			},
		},
	},
	header: {
		searchPlaceHolder: "Search by product",
		importXML: "Import via XML",
		transferProducts: "Transfer products",
		addProducts: "Add products",
		addProductsManually: "Add products manually",
		actionsToolbar: "Storage Header Actions",
		importViaXlsx: "Import via Excel",
	},
	table: {
		columns: {
			name: "product",
			category: "category",
			quantity: "quantity",
			action: "action",
			lastCost: "Last price",
			avgCost: "Average price",
			totalCost: "Total cost",
		},
		actions: {
			zeroStorage: "Zero stock",
			removeProducts: "Remove products",
			label: "Batch actions",
			message: "Select the check box for batch actions",
		},
		confirmationModal: {
			warnignHiddenProductsInSearch:
				"Warning, some products may be hidden because of the search, clear the search to continue",
			deleteSingle: {
				title: "Remove Product",
				message:
					"By confirming the action you will permanently remove these items from the Inventory. Do you want to continue?",
				confirmMessage: "Yes, I want to remove",
			},
			deleteMultiple: {
				title: "Remove Product",
				message:
					"By confirming the action you will permanently remove these items from the Inventory. Do you want to continue?",
				confirmMessage: "Yes, I want to remove",
			},
			zero: {
				title: "Zero products quantity",
				messagePrefix: "You are about to zero the quantity",
				allMessage: "of all selected products ({{total}} products).",
				selectedMessage: "of {{selectedTotal}} selected products.",
				messageSuffix: "Are you sure you want to continue?",
				confirmMessage: "Zero products",
			},
		},
		filters: {
			categoryPlaceholder: "Filter by category",
			productPlaceholder: "Search by product name",
			suggestions: "Suggestions",
			other: "Other",
		},
		selectedProductsCount: "All selected products: {{total}} products",
	},
	inputViaXlsx: {
		header: {
			title: "Import products via Excel",
		},
		layout: {
			importProductsTable: "Import your products table",
			tutorial: "Add 1 or more products at once by importing a spreadsheet.",
		},
		form: {
			totalProducts: "Total products",
			successfullyImported: "Imported products",
			productsWithErrors: "Products with errors",
			downloadInvalidSheet: "Download table with errors",
			alert: {
				title: "Products with errors",
				message:
					"We identified some products with incorrect information. Download the spreadsheet with errors, correct the data, and then import again.",
			},
			tooltip: {
				totalProducts: "Your table had {{totalProducts}} products",
				successfullyImported:
					"{{totalProducts}} products have already been imported successfully to your storage",
				productsWithErrors: "Download the spreadsheet with errors and upload again",
			},
		},
		sheet: {
			columns: {
				productName: "Product",
				quantity: "Quantity",
				unit: "Unit of measure",
				costPrice: "Cost price",
				costType: "Cost type",
			},
			costType: {
				byUnit: "Unit cost",
				byTotal: "Total cost",
			},
			sampleFileName: "example_input_products",
			errorFileName: "input_products_with_errors",
		},
	},
};
